import updateInformationRequest from 'hb-react/shared/components/User/UpdateInformationModal/requests/updateUserRequest';

export const commands = ({ currentUser, updateCurrentUser }) => {
  const update = async (changeSet) => {
    const data = changeSet
      .filter(({ selected }) => selected)
      .reduce(
        (fields, { envelope, payload: { to } }) => ({
          ...fields,
          ...(envelope ? { [envelope]: to } : to),
        }),
        {},
      );

    const {
      data: { user },
    } = await updateInformationRequest(currentUser, data);

    const updatedUser = { ...data, ...user };

    updateCurrentUser(updatedUser);

    if (window?.AlumniConnect?.currentUser) {
      AlumniConnect.currentUser = {
        ...AlumniConnect.currentUser,
        updatedUser,
      };
    }
  };

  return {
    update,
  };
};
